export const SEVERITY_COLORS = {
  CRITICAL: { background: '#dc3545', color: '#fff' },
  HIGH:     { background: '#fd7e14', color: '#fff' },
  MEDIUM:   { background: '#ffc107', color: '#212529' },
  LOW:      { background: '#6c757d', color: '#fff' },
  INFO:     { background: '#17a2b8', color: '#fff' },
};

export const SEVERITY_BORDER_CLASS = {
  CRITICAL: 'border-danger',
  HIGH:     'border-warning',
  MEDIUM:   'border-info',
  LOW:      'border-secondary',
  INFO:     'border-light',
};

export const SEVERITY_KEYS = [
  { key: 'CRITICAL', color: '#dc3545' },
  { key: 'HIGH',     color: '#fd7e14' },
  { key: 'MEDIUM',   color: '#ffc107' },
  { key: 'LOW',      color: '#6c757d' },
  { key: 'INFO',     color: '#17a2b8' },
];
